var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 16.25H10.0083M19.0053 7.25063C16.6329 5.07666 13.4713 3.75 9.99982 3.75C6.52837 3.75 3.36678 5.07666 0.994385 7.25063M3.9432 10.2025C5.5583 8.77971 7.67831 7.91667 9.9999 7.91667C12.3215 7.91667 14.4415 8.77971 16.0566 10.2025M13.0819 13.1459C12.2326 12.4802 11.1626 12.0833 9.99982 12.0833C8.81949 12.0833 7.73469 12.4923 6.87939 13.1763",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.b7cb47a6b02f80b22449774f44375450.svg";
export { ForwardRef as ReactComponent };